import React from 'react'
import Insta from '../pics/icons/instagram-round-line-icon.png'
import Facebook from '../pics/icons/facebook-line-icon.png'
import Linkedin from '../pics/icons/linkedin-line-icon.png'
// import Bsky from '../pics/icons/square-bluesky-brands-solid-black.png'
// import BskyWhite from '../pics/icons/square-bluesky-brands-solid.png'
import InstaWhite from '../pics/icons/instagram-round-line-icon-white.png'
import X from '../pics/icons/logo-black.png'
import xWhite from '../pics/icons/logo-white.png'
import FacebookWhite from '../pics/icons/facebook-line-icon-white.png'
import LinkedinWhite from '../pics/icons/linkedin-line-icon-white.png'

export default function SocialMediaLinks({color}){
	return <section className="social">
		<a className='socialMediaImagesLinks' target='_blank' href="http://instagram.com/barcelonacodeschool">
		<img src={color==='white'?InstaWhite:Insta} alt='Barcelona Code School Instagram'/>
		</a>
		<a className='socialMediaImagesLinks' target='_blank' href="https://www.linkedin.com/school/barcelona-code-school">
		<img src={color==='white'? LinkedinWhite:Linkedin} alt='Barcelona Code School Linkedin'/>
		</a>
		<a className='socialMediaImagesLinks' target='_blank' href="https://x.com/BCNcodeschool">
		<img src={color==='white'? xWhite:X} alt='Barcelona Code School on X'/>
		</a>
		<a className='socialMediaImagesLinks' target='_blank' href="https://www.facebook.com/BarcelonaCodingSchool/">
		<img src={color==='white'? FacebookWhite:Facebook} alt='Barcelona Code School Facebook'/>
		</a>
		</section>
}

